import Logo from "components/global/Logo";
import {
  Link,
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import Spacer from "components/global/Spacer";
import AuthLayout, {
  AuthProviderButton,
  FormHeader,
} from "components/auth/AuthLayout";
import { initialState } from "api/rootReducer";
import instagramIcon from "assets/icons/instagramDefault.svg";
import axios from "axios";
import { getCookie, planTypeMap } from "utils/utils";
import { trackEvents } from "api";

const socialProviders = [
  {
    name: "instagram",
    buttonText: "Continue with Instagram Business",
    target: `${initialState.api_host}auth/instagram`,
    icon: instagramIcon,
  },
];

const RegisterWithSocials = () => {
  const router = useHistory();
  const { search } = useLocation();

  const redirectPath = new URLSearchParams(search).get("return_to");
  const full_name = new URLSearchParams(search).get("full_name");
  const invite = new URLSearchParams(search).get("invite");
  const planType = new URLSearchParams(search).get("plan");
  const plan = planType ? planTypeMap[planType.toLowerCase()] : null;
  const postpaddyMobile = new URLSearchParams(search).get("postpaddy-mobile");
  const referralCode = new URLSearchParams(search).get("referralCode");
  const social = new URLSearchParams(search).get("social");

  const trackSignup = async () => {
    const date = new Date();
    const utm_source = getCookie("utm_source");
    const utm_medium = getCookie("utm_medium");
    const utm_campaign = getCookie("utm_campaign");
    const utm_content = getCookie("utm_content");

    const data = {
      event_name: "clicked_signup",
      event_properties: {
        date: date,
        account_type: planType,
      },
    };
    if (utm_campaign || utm_content || utm_medium || utm_source) {
      data.utm_tags = {
        source: utm_source,
        medium: utm_medium,
        campaign: utm_campaign,
        content: utm_content,
      };
    }

    try {
      await trackEvents(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSocialAuth = async (provider) => {
    const url = `${initialState.api_host}auth/${provider}`;

    try {
      const res = await axios.get(url);
      if (res.data?.data?.redirect) {
        trackSignup();
        localStorage.setItem("redirect", redirectPath);
        localStorage.setItem("socialAuthProvider", social);
        window.location.href = res.data.data.redirect;
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <AuthLayout>
      <FormHeader>
        <Logo />
        <p className="l3">
          Already have an account?{" "}
          <Link
            to={
              redirectPath
                ? `/sign-in${search}`
                : postpaddyMobile
                ? "/sign-in?postpaddy-mobile=true"
                : "/sign-in"
            }
            className="signInText l3"
          >
            Sign in
          </Link>
        </p>
      </FormHeader>
      <Spacer y={3.2} />
      <h4 className="title">Sign up to PostPaddy</h4>
      <Spacer y={0.6} />
      <p className="l3 colorBodyText">
        Let's help setup your account. PostPaddy requires certain permissions to
        help you create captions, schedule posts and setup automations.
      </p>
      <Spacer y={2.4} />
      {socialProviders.map((provider) => (
        <AuthProviderButton
          key={provider.name}
          onClick={() => handleSocialAuth(provider.name)}
        >
          <img src={provider.icon} alt={provider.name} className="icon" />
          <span className="l2">{provider.buttonText}</span>
        </AuthProviderButton>
      ))}

      <div>
        <Spacer y={2.4} yMobile={1.4} />
        <p className="l4 colorBodyText legal textCenter">
          By continuing, you agree to PostPaddy's{" "}
          <a
            href="https://postpaddy.com/pages/terms-of-service "
            className="colorSecondary l4 textNoWrap"
          >
            Terms of service
          </a>{" "}
          and{" "}
          <a
            href="https://postpaddy.com/pages/privacy-policy"
            className="colorSecondary l4 textNoWrap"
          >
            Privacy policy
          </a>
          .
        </p>
      </div>
    </AuthLayout>
  );
};

export default RegisterWithSocials;
